import { useQuoteApi } from './useQuoteApi';
import { useQuoteGetters } from './useQuoteGetters';
import { useQuoteHelpers } from './useQuoteHelpers';

import type { UseQuote } from './types';
export function useQuote(): UseQuote {
  return {
    ...useQuoteApi(),
    ...useQuoteGetters(),
    ...useQuoteHelpers(),
  };
}
